import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Navbar } from "@/components/yc/Nav";
import { api } from "@/lib/api";

const PaymentReturn = () => {
    const [search] = useSearchParams();
    const navigate = useNavigate();
    const sessionId = search.get("session_id");
    const purpose = search.get("purpose");
    const campaignId = search.get("campaign_id");
    const [status, setStatus] = useState("checking");
    const [tries, setTries] = useState(0);

    const poll = useCallback(async () => {
        if (!sessionId) { setStatus("error"); return; }
        try {
            const url = (purpose === "subscription" || purpose === "plan")
                ? `/subscriptions/status/${sessionId}`
                : `/payments/status/${sessionId}`;
            const r = await api.get(url);
            if (r.data.payment_status === "paid") setStatus("paid");
            else if (r.data.status === "expired") setStatus("expired");
            else { setTries((t) => t + 1); setTimeout(poll, 2000); }
        } catch (e) {
            setStatus("error");
        }
    }, [sessionId, purpose]);

    useEffect(() => {
        if (tries >= 6 && status === "checking") setStatus("timeout");
    }, [tries, status]);

    useEffect(() => { poll(); }, [poll]);

    return (
        <div className="min-h-screen bg-yc-cream">
            <Navbar />
            <section className="max-w-2xl mx-auto px-6 md:px-12 py-24">
                <div className="yc-card p-10 text-center" data-testid="payment-return-card">
                    {status === "checking" && (<>
                        <div className="yc-overline">Processing</div>
                        <h1 className="font-heading text-4xl font-black tracking-tighter mt-3">Confirming your payment…</h1>
                        <p className="text-sm text-yc-ink/70 mt-3">Hang tight — this usually takes a few seconds.</p>
                    </>)}
                    {status === "paid" && (() => {
                        const copy = {
                            plan: { h: "Your plan is live.", p: "Video allowance granted and the full network is unlocked. Your dedicated account manager will be in touch.", to: "/brand/dashboard" },
                            subscription: { h: "Your plan is live.", p: "Video allowance granted — the full network is unlocked.", to: "/brand/dashboard" },
                            taster: { h: "Taster booked.", p: "One standard video is in your allowance and full creator profiles are unlocked for 30 days. We'll be in touch to book your strategy call.", to: "/brand/membership" },
                            topup: { h: "Videos added.", p: "Your top-up bundle has been added to your allowance — it never expires.", to: "/brand/membership" },
                            addon: { h: "Add-on paid.", p: "Your add-on format is attached to the campaign and in the production queue.", to: "/brand/campaigns" },
                        }[purpose] || { h: "Payment complete.", p: "You're all set.", to: "/brand/dashboard" };
                        return (<>
                            <div className="yc-overline text-yc-blue">Success</div>
                            <h1 className="font-heading text-4xl font-black tracking-tighter mt-3">{copy.h}</h1>
                            <p className="text-sm text-yc-ink/70 mt-3">{copy.p}</p>
                            <button data-testid="payment-continue" onClick={() => navigate(copy.to)} className="yc-btn-primary mt-8">Continue →</button>
                        </>);
                    })()}
                    {(status === "expired" || status === "error" || status === "timeout") && (<>
                        <div className="yc-overline text-yc-pink">Payment not completed</div>
                        <h1 className="font-heading text-4xl font-black tracking-tighter mt-3">Something went wrong.</h1>
                        <p className="text-sm text-yc-ink/70 mt-3">Try again or contact support.</p>
                        <button onClick={() => navigate("/brand/membership")} className="yc-btn-primary mt-8">Back to Plan & Videos</button>
                    </>)}
                </div>
            </section>
        </div>
    );
};

export default PaymentReturn;
